import {viewTransition} from '$c3local/transition.js';

/**
 * @typedef {{locations: string[], organizations: number[], types: number[], categories: number[], innerText: string}} JobMeta
 */

export function initFilters() {
    /** @type {HTMLFormElement} */
    const filters = document.querySelector('.job-filter');
    if (!filters) {
        return;
    }

    const jobs = document.querySelectorAll('.job');

    /** @type {Map<HTMLDivElement, JobMeta>} */
    const jobData = new Map();

    for (const job of jobs) {
        jobData.set(job, {
            ...JSON.parse(job.dataset.meta),
            innerText: job.innerText.toLowerCase()
        });
    }

    filters.addEventListener('submit', e => {
        e.preventDefault();
    });

    /** @type {NodeListOf<HTMLInputElement>} */
    const desktopTypeSelects = filters.querySelectorAll('[name="job-category"]');
    /** @type {HTMLInputElement} */
    const mobileTypeSelect = filters.querySelector('[name="job-category-mobile"]');

    mobileTypeSelect.addEventListener('input', e => {
        for (const radio of desktopTypeSelects) {
            radio.checked = radio.value === mobileTypeSelect.value;
        }
    });

    filters.addEventListener('input', () => {
        const data = new FormData(filters);

        const company = parseInt(/** @type {string} */ data.get('job-company') ?? '0');
        const location = data.get('job-location') ?? '0';
        const type = parseInt(/** @type {string} */ data.get('job-type') ?? '0');
        const category = parseInt(/** @type {string} */ data.get('job-category') ?? '0');

        const search = data.get('job-search');

        viewTransition(() => {
            for (const [element, meta] of jobData) {
                if (company !== 0 && !meta.organizations.includes(company)) {
                    hide(element);
                    continue;
                }

                if (location !== '0' && !meta.locations.includes(location)) {
                    hide(element);
                    continue;
                }

                if (type !== 0 && !meta.types.includes(type)) {
                    hide(element);
                    continue;
                }

                if (category !== 0 && !meta.categories.includes(category)) {
                    hide(element);
                    continue;
                }

                if (search.length && !meta.innerText.includes(search.toLowerCase())) {
                    hide(element);
                    continue;
                }

                show(element);
            }
        });
    });
}

/**
 *
 * @param {HTMLElement} element
 */
function hide(element) {
    element.hidden = true;
}

/**
 *
 * @param {HTMLElement} element
 */
function show(element) {
    element.hidden = false;
}